import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { CategoryRepositoryImpl } from "../../domain/categoryRepositoryImpl/CategoryRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { DEFAULT_CURRENCY } from "../shared/config";

const categoryRepo = CategoryRepositoryImpl.getInstance();

const useGetCategories = (moreProductsPerCategory = false) => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["currencyAndCategories", auth, moreProductsPerCategory],
      queryFn: async () => {
        const categories = await categoryRepo.getCurrencyAndCategories(apiUrl, auth, moreProductsPerCategory);
        return categories;
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { categories: data?.categories || [], currency: data ? data.currency : DEFAULT_CURRENCY, isLoading };
};

export { useGetCategories };
